export default __webpack_public_path__ + "maps-examples-view-annotation-marker-thumbnail-480-705b4ca295c01592cb2a8d0f9ff00ebf.png";